import request from '@/utils/request'
import {getEnvConfig} from "@/utils/env";



export function getQiyuConfig(params) {
  return request({
    url: '/common/qiyu/config',
    method: 'GET',
    params
  })
}

export function getQrCodeDetail(params) {
  return request({
    url: '/photograph/qrCode',
    method: 'GET',
    params
  })
}

//切换企业
export function switchEnterprise(params) {
  return request({
    url: '/wechat/user/switchEnterprise',
    method: 'PUT',
    data: params
  })
}

//意见反馈
export function feedback(params) {
  return request({
    url: '/app/message/problem',
    method: 'POST',
    data: params
  })
}

//更换账号，老手机号短信验证
export function checkNote(params) {
  return request({
    url: `/wechat/setting/checkNote`,
    method: 'POST',
    data: params
  })
}

//修改手机号
export function modifyPhone(params) {
  return request({
    url: '/wechat/setting/modifyPhone',
    method: 'POST',
    data: params
  })
}

//初始化密码
export function initPassword(params) {
  return request({
    url: '/wechat/setting/initPassword',
    method: 'POST',
    data: params
  })
}

//修改密码
export function modifyPassword(params) {
  return request({
    url: '/wechat/setting/modifyPassword',
    method: 'POST',
    data: params
  })
}

export function passwordNote(params) {
  return request({
    url: '/common/pwd/note',
    method: 'POST',
    params
  })
}

export function oldPassword(params) {
  return request({
    url: '/common/pwd/old_pwd',
    method: 'POST',
    params
  })
}

//退出登录
export function logoutApi(params) {
  return request({
    url: `/logout`,
    method: 'GET',
    params
  })
}

//注销账号
export function deregisterAccount() {
  return request({
    url: `/wechat/logout`,
    method: 'POST'
  })
}

//获取最新app版本号
export function getLatestAppVersion(params) {
  if (process.env.newConnect === '1') {
    return {
      "code": 0,
      "success": true,
      "data": {
      }
    }
  }
  const envConfig = getEnvConfig();
  return request({
    url: `/app/message`,
    method: 'GET',
    params,
    baseURL: envConfig?.intranet === 1 ? envConfig.personalAppUrl : process.env.VITE_API_BASE_URL
  })
}

// 更换头像
export function switchAvatarId(params) {
  return request({
    url: `app/user/switchAvatarId/v2.6.2`,
    method: 'PUT',
    params
  })
}
